import { useQuery } from '@tanstack/react-query';

import { getInvoicingDataService } from '../services/invoicing.service';

/** Se invalida al subir o quitar un sello: es justo el evento que cambia estos datos. */
export const INVOICING_DATA_QUERY_KEY = ['invoicing', 'v2', 'operations-user'];

/**
 * Los datos del emisor de `GET /operations/user` en el fiscal-engine: nombre,
 * RFC, código postal y regímenes, por el `user_id` del token y sin pasar por el
 * vínculo con el SAT. Es la variante de la facturación nueva de `useCsdStatus`,
 * que lee el mismo endpoint. Sin respuesta, el emisor se arma con el sello y el
 * perfil fiscal.
 */
export const useInvoicingData = () =>
  useQuery({
    queryKey: INVOICING_DATA_QUERY_KEY,
    queryFn: getInvoicingDataService,
    staleTime: 60_000,
  });
